var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    attrs: {
      title: _vm.$gettext("Import"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "ul",
              {
                staticClass: "widget-list widget-links cw-import-widget",
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "cw-import-widget-archive",
                  },
                  [
                    _c(
                      "button",
                      {
                        on: {
                          click: _vm.importElements,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Seiten importieren")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "cw-import-widget-copy",
                  },
                  [
                    _c(
                      "button",
                      {
                        on: {
                          click: _vm.copyElements,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Seiten kopieren")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.inCourseContext && _vm.userIsTeacher
                  ? _c(
                      "li",
                      {
                        staticClass: "cw-action-widget-link",
                      },
                      [
                        _c(
                          "button",
                          {
                            on: {
                              click: _vm.linkElement,
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Seiten verknüpfen")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }